export const SITE_URL = "https://thecardlight.com";

export const PRICING = {
  freeReadings: 3,
  premiumReadings: 12,
  monthly: "$7.99",
  annual: "$59.99",
  annualPerMonth: "$5.00",
  annualSaving: "37%",
};

export const FREE_PROMISE = `Your first ${PRICING.freeReadings} readings are free — no card required. Sign in with Google or your email address to receive them.`;
export const SIGNED_IN_PROMISE = {
  free: (left) => (left > 0
    ? `You have ${left} of your ${PRICING.freeReadings} free readings left — no card required.`
    : `You've used your ${PRICING.freeReadings} free readings. Premium adds ${PRICING.premiumReadings} full readings each month.`),
  premium: `Your Premium plan includes ${PRICING.premiumReadings} full readings each month.`,
};

export const PRIVACY_LINE =
  "To write your reading, your question and cards are sent to our AI provider (Anthropic's Claude, through Emergent's AI service). Saved readings stay in your journal until you delete them.";

export const SUPPORT_CONTACT = "support@thecardlight.com";

// TODO(owner): fill in to show the founder block on /about. Leave name empty to hide it.
export const FOUNDER = {
  name: "",
  photo: "",
  profileUrl: "",
  profileLabel: "",
  story: [],
};

// TODO(owner): add real, permitted quotes: { quote, name, context, photo? }. Section stays hidden while empty.
export const TESTIMONIALS = [];

// TODO(owner): add real, dated external mentions: { label, source, date, url }. Strip stays hidden while empty.
export const THIRD_PARTY = [];

export const FAQ = [
  {
    q: "Is The Cardlight free?",
    a: `Yes, to start. Your first ${PRICING.freeReadings} full readings are free, with no card required — you just sign in with Google or your email address. After that, Premium is ${PRICING.monthly}/month or ${PRICING.annual}/year for ${PRICING.premiumReadings} full readings a month.`,
  },
  {
    q: "Will the reading actually be about my question?",
    a: "Yes. The exact question you type is given to the AI together with each card you drew, its position in the spread, and whether it came up reversed. It's asked to answer your question directly — not to write a generic paragraph that could apply to anyone.",
  },
  {
    q: "How does the AI use my question?",
    a: "When you ask for a reading, your question, the deck, the spread and the cards you drew are sent through Emergent's AI service to Anthropic's Claude, which writes the reading. For a follow-up question, the original question, the reading and earlier follow-ups are sent too. Those providers handle the text under their own terms.",
  },
  {
    q: "What happens to my question and readings?",
    a: "If you save a reading, its question, cards, interpretation, reflections and follow-ups are stored with your account and shown only to you in your journal. You can delete a saved reading anytime. Daily Ritual cards are also stored with your account. See the Privacy Policy for everything we collect and the services involved.",
  },
  {
    q: "What decks can I use?",
    a: "Two: the Whispering Path Tarot, a full 78-card tarot deck with reversals, and the Whispering Path Oracle, 44 illustrated cards of elemental guidance. Spreads range from a single daily card to a five-card Deep Dive.",
  },
  {
    q: "Do the Daily Ritual and follow-up questions use up readings?",
    a: "No. The Daily Ritual card and up to 3 follow-up questions per saved reading don't count against your full readings.",
  },
  {
    q: "Can I cancel? Do you give refunds?",
    a: "You can cancel anytime from the Stripe billing portal (tap your Premium badge). You keep Premium until the end of the period you paid for. Cancelling doesn't refund the current payment, and we don't give prorated refunds except where the law requires it. If a charge looks wrong, email support@thecardlight.com and we'll review it.",
  },
];
